import { Seo } from "components/Seo";
import GetCompany from "./GetCompany";
import NoCompany from "./NoCompany";
import HolidayInfoBanner from "components/HolidayInfoBanner";
import SessionKiller from "components/SessionKiller";

const haveCompany: boolean = true;

const MyAccount = () => {
  return (
    <>
      <Seo title="Mine bedrifter" />
      <SessionKiller></SessionKiller>
      <HolidayInfoBanner></HolidayInfoBanner>
          {haveCompany?(
            <GetCompany />
          ):(
            <NoCompany />
          )}
    </>
  );
};

export default MyAccount;
